import { hr } from "@nuxt/ui/locale";
import { extendLocale } from "@nuxt/ui/composables/defineLocale";
const messages = {
  alert: {
    close: "Zatvori"
  },
  authForm: {
    hidePassword: "Sakrij lozinku",
    showPassword: "Prikaži lozinku",
    submit: "Nastavi"
  },
  banner: {
    close: "Zatvori"
  },
  calendar: {
    nextMonth: "Sledeći mesec",
    nextYear: "Sledeća godina",
    prevMonth: "Prethodni mesec",
    prevYear: "Prethodna godina"
  },
  carousel: {
    dots: "Izaberite slajd za prikaz",
    goto: "Idi na slajd {slide}",
    next: "Sledeći",
    prev: "Prethodni"
  },
  chatPrompt: {
    placeholder: "Unesite poruku ovde…"
  },
  chatPromptSubmit: {
    label: "Pošalji upit"
  },
  chatReasoning: {
    thinking: "Razmišlja…",
    thought: "Razmislio",
    thoughtFor: "Razmišljao {duration}"
  },
  colorMode: {
    dark: "Tamno",
    light: "Svetlo",
    switchToDark: "Pređi na tamni režim",
    switchToLight: "Pređi na svetli režim",
    system: "Sistem"
  },
  commandPalette: {
    back: "Nazad",
    close: "Zatvori",
    noData: "Nema podataka",
    noMatch: "Nema rezultata",
    placeholder: "Unesite komandu ili pretražite…"
  },
  contentSearch: {
    links: "Linkovi",
    search: "Rezultati",
    theme: "Tema"
  },
  contentSearchButton: {
    label: "Pretraga…"
  },
  contentToc: {
    title: "Na ovoj stranici"
  },
  dropdownMenu: {
    noMatch: "Nema rezultata",
    search: "Pretraga…"
  },
  dashboardSearch: {
    theme: "Tema"
  },
  dashboardSearchButton: {
    label: "Pretraga…"
  },
  dashboardSidebarCollapse: {
    collapse: "Skupi bočnu traku",
    expand: "Proširi bočnu traku"
  },
  dashboardSidebarToggle: {
    close: "Zatvori bočnu traku",
    open: "Otvori bočnu traku"
  },
  error: {
    clear: "Nazad na početnu"
  },
  fileUpload: {
    removeFile: "Ukloni {filename}"
  },
  header: {
    close: "Zatvori meni",
    open: "Otvori meni"
  },
  inputMenu: {
    create: "Kreiraj „{label}”",
    noData: "Nema podataka",
    noMatch: "Nema rezultata"
  },
  inputNumber: {
    decrement: "Smanji",
    increment: "Povećaj"
  },
  listbox: {
    noData: "Nema podataka",
    noMatch: "Nema rezultata",
    search: "Pretraga…"
  },
  modal: {
    close: "Zatvori"
  },
  pricingTable: {
    caption: "Poređenje cenovnih planova"
  },
  prose: {
    codeCollapse: {
      closeText: "Skupi",
      name: "kod",
      openText: "Proširi"
    },
    collapsible: {
      closeText: "Sakrij",
      name: "svojstva",
      openText: "Prikaži"
    },
    pre: {
      copy: "Kopiraj kod"
    },
    prompt: {
      copy: "Kopiraj upit",
      openIn: "Otvori u {name}"
    }
  },
  sidebar: {
    close: "Zatvori",
    toggle: "Prikaži ili sakrij"
  },
  selectMenu: {
    create: "Kreiraj „{label}”",
    noData: "Nema podataka",
    noMatch: "Nema rezultata",
    search: "Pretraga…"
  },
  slideover: {
    close: "Zatvori"
  },
  table: {
    noData: "Nema podataka"
  },
  toast: {
    close: "Zatvori"
  }
};
const uiSr = extendLocale(hr, { name: "Srpski", messages });
export {
  uiSr
};
//# sourceMappingURL=index59.js.map
